// extracted by mini-css-extract-plugin
export default {"StaffReviewerRow__container":"Il710D6Em5"};